import React, {Component, Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {browserHistory} from "react-router";
import I18n from 'lib/i18n/i18n';
import UserActions from "lib/userActions";
import ItemDetails from 'components/myAccount/itemDetails';
import ThreeDotsMenu from 'components/myAccount/threeDotsMenu';
import { imageUrl, parseShortenedDate } from '../../helpers/ApplicationHelper';
import {statesForOnlineCancallation} from 'helpers/ApplicationHelper';

import {
    dollarsWithoutCents,
    dataAutomationAttr,

    VALIDATION_NEEDED,
    ESTIMATED,
    ESTIMATION_READY,
    EVALUATION_READY,
    EVALUATION_BID,
    BIDDING_FINISHED,
    PENDING_SALE,
    ON_HOLD,
    SALE_SCHEDULED,
    RETURN_PENDING,
    DELIVERED,
    SHIPPING,
    DONE_SOLD,
    DONE,

    IN_TRANSIT,
    PICKUP_WAITING,
    ADDRESS_WAITING,
    PICKUP_NO_SHOW,
    NEW,
    UNPACKED,
    PENDING_AUCTION,
    EVALUATED,
    JEWELRY_FOR_EXPERIMENTS,

    isMobile,
    isShipBack,
} from 'helpers/ApplicationHelper';

import Item from '../item';

import {siteItemPage, getStatus, ONLINE_CANCELLATION_REASON_NUMBER} from 'helpers/itemHelper';
import {getBundleWithItems, abortItem, getUserBundles, clearSelectedBundle} from 'actions/myAccount';
import { getPaymentDetails }    from 'actions/user';
import {getItemsCount} from "../../actions/itemsCount";
import rootStore        from 'reducers';
import PopupJBSuccessFees from 'components/myAccount/popupJBSuccessFees';
import PopupJBGetPaid from 'components/myAccount/popupJBGetPaid';
import {SmallPrimaryButton, SmallLinkButton} from "@worthy-npm/clarity";
import i18n from "lib/i18n/i18n";
import { preShipmentUi } from "../../actions/personalize";
import popupSubmitItemCancelleation from "../popups/popupSubmitItemCancellation";

class BundleDetails extends Component {

    constructor(props) {
        super(props);
        this.isMobile = isMobile();
        this.state = {
            items: props.bundle.items || [],
            allFinished: props.bundle.items && props.bundle.items.every((item) => {
                return [
                    ON_HOLD,
                    PENDING_SALE,
                    EVALUATION_READY,
                    SALE_SCHEDULED,
                    RETURN_PENDING,
                    DONE].includes(item.workflow_state)
            }),
            abortedItem: null,
        };
        this.isSingleItem = this.itemsCount === 1;
        this.multipleItems = this.itemsCount > 1;
        this.renderParent= this.renderParent.bind(this);
    }

    componentDidMount() {
        const { open, ADO } = this.props;
        if (open) {
            UserActions.myAccount(`Seller viewed bundle #${this.bundle.id}`, this.bundle.id, 'Bundle');
        } else {
            if (this.isMobile && this.isSingleItem &&
                (this.bundle.single_item && !this.bundle.single_item.aborted) &&
                JEWELRY_FOR_EXPERIMENTS.includes(this.bundle.single_item && this.bundle.single_item.item_type) &&
                ADO && ADO.user) {
                // TODO: this api request is currently serialized after getItem. we should try to parallelize them.
                preShipmentUi(this.bundle.single_item, ADO.user).payload
                    .then(payload => {
                        const i = { ...this.bundle.single_item };
                        i['bundle'] = { workflow_state: this.bundle['workflow_state'] };

                        const analysis = Item.analyzeItemState(
                            { ...i, id: this.bundle.single_item.public_id},
                            ADO, payload.data, {});
                        this.setState({
                            eligibleForLP: analysis.anyListing
                        });
                    }).catch(e => console.error(e))
            } else {
                this.setState({ eligibleForLP: false });
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.isSingleItem = this.itemsCount === 1;
        this.multipleItems = this.itemsCount > 1;
        if(this.itemsCount === 0) this.props.back();

    }

    get bundle() {
        return this.props.bundle;
    }

    get itemsCount() {
            return this.props.count || this.state.items.length;
    }

    get clickable() {
        const singleItem = this.bundle.single_item;

        if (isShipBack(singleItem)) {
          return true;
        }

        if (singleItem) {
            if (singleItem.workflow_state === PENDING_AUCTION && singleItem.format === 'tender')
                return false;
            if (singleItem.is_direct_offer)
                return false;

            if (singleItem.major_subset_type === 'Watch') {
                return [
                    ADDRESS_WAITING,
                    EVALUATED
                ].includes(this.bundle.workflow_state) || [
                    VALIDATION_NEEDED,
                    ESTIMATION_READY,
                    PENDING_AUCTION,
                    PENDING_SALE,
                    EVALUATION_READY,
                    BIDDING_FINISHED,
                    EVALUATION_BID
                ].includes(singleItem.workflow_state);
            }
        }

        return this.multipleItems ||
            !([RETURN_PENDING,
                DONE,
                SHIPPING].includes(singleItem && singleItem.workflow_state)) ||
            [ADDRESS_WAITING, PICKUP_WAITING].includes(this.bundle.workflow_state) ||
            (singleItem && singleItem.workflow_state !== DONE && this.bundle.workflow_state !== DONE && !this.bundle.aborted);
    }

    get singleAndPreDelivery() {
        return this.isSingleItem && statesForOnlineCancallation.includes(this.bundle.single_item?.workflow_state) && !this.bundle.single_item.aborted ;
    }

    get totalValue() {
        let sum = 0;
        this.state.items.forEach((item) => {
            let priceGuaranteeNotMet = (item.price_guarantee || item.advance_payment) && (item.reserve_price > item.highest_bid);
            let amount = priceGuaranteeNotMet ? item.reserve_price : item.highest_bid
            sum += (amount || 0 );
        })
        return sum;
    }

    get statusText() {
        if (this.isMobile && this.bundle.single_item && [this.type, this.bundle.type].includes('standard')) {
            try {
                let status = getStatus(this.bundle, this.bundle['single_item'], 1);
                if (status.includes('Call scheduled for') && this.bundle.single_item.trends_page && this.bundle.workflow_state === ESTIMATED ) {
                    return <div className="text-with-btn d-flex">
                        <span>{i18n.getString('myAccount::bundle::callScheduled')}</span>
                        {this.trendsLink()}
                    </div>
                }
                return status;
            } catch(e) {
                    console.error(e);
            }
        }
        if (this.transferDetails) {
            return <span><b>{dollarsWithoutCents(this.transferDetails.amount)} </b>{`payment ${this.transferDetails.done ? 'done' : 'being processed'}`}</span>;
        }
        switch (this.bundle.workflow_state) {
            case NEW:
                return this.bundle.appointment_time ? <Fragment>{i18n.getString('myAccount::bundle::callScheduledFor')} {parseShortenedDate(this.bundle.appointment_time)}</Fragment> : null;
            case PICKUP_WAITING:
                return this.pickupWaiting();
            case IN_TRANSIT:
                return 'In transit';
            case DELIVERED:
            case UNPACKED:
                if (this.bundle.single_item && this.bundle.single_item.format === 'tender') return 'Processing';
                if (this.bundle.single_item && this.bundle.single_item.workflow_state === PENDING_AUCTION) return 'Pending auction';
                else return `Arrived on ${this.bundle.arrived_at}`;
            case DONE: {
                return this.bundle.single_item?.reject_reason === ONLINE_CANCELLATION_REASON_NUMBER && 'Cancelled' || this.bundle.aborted && 'Aborted' || '';
            }
        }
    }

    get transferDetails() {
        return this.bundle.transfer_details || this.props.MyAccount.transferDetails;
    }

    get anyInAuction() {
        return this.bundle.items ? this.bundle.items.filter(item => [EVALUATION_BID, BIDDING_FINISHED].includes(item.workflow_state)).length : false;
    }

    pickupWaiting = () => {
        if (!this.bundle.shipment_method || this.bundle.shipment_method.toLowerCase() === 'none')
            return <Fragment>{this.trendsLink()}{i18n.getString('myAccount::bundle::awaitingShipment')}</Fragment>
        if (this.bundle.shipment_method === 'In-Person Drop Off')
            return <Fragment> {this.trendsLink()}{i18n.getString('myAccount::bundle::pendingOfficeDropOff')}</Fragment>
        if (this.bundle.pickup_time_range)
            return <Fragment>{this.trendsLink()}{i18n.getString('myAccount::bundle::pickupScheduledFor')} {this.bundle.pickup_time_range}</Fragment>
        return <Fragment> {this.trendsLink()}{i18n.getString('myAccount::bundle::pendingDropOffAtFedex')}</Fragment>
    }

    scheduleACall = e => {
        if (typeof e === 'function') {
            e.stopPropagation ? e.stopPropagation() : e(); // e() for the case when target is an element from Clarity
        }
        window.location.pathname = this.bundle.type === 'jewelry_box' && this.initialWorkflowState() ? `/multiple_jewelry/${this.bundle.id}` : `/item/${this.bundle.main_item_id}`;
    }

    initialWorkflowState(){
        return this.isSingleItem ? this.bundle.single_item.workflow_state === ESTIMATION_READY : this.bundle.workflow_state === NEW;
    }

    toItemPage = (e) => {
        if (typeof e === 'function') {
            e.stopPropagation ? e.stopPropagation() : e(); // e() for the case when target is an element from Clarity
        }
        window.location.pathname = `/item/${this.bundle.single_item.public_id || this.state.items[0].public_id}`;
    }

    toTrendsPage = (e, trendsPage) => {
        e.stopPropagation()
        browserHistory.push(`${trendsPage === 'light' ? `/item/${this.bundle.single_item.public_id}/lightTrends` : `/listing/${this.bundle.single_item.public_id}/trends`}`)
    }

    trendsLink = () => {
        let trendsLink = null;
        if (this.bundle.single_item && this.bundle.single_item.trends_page) {
            if(this.isMobile) {
                trendsLink = <div className="trends-link-container"> <SmallLinkButton
                    text={i18n.getString('myAccount::bundle::seeValueSummary')}
                    click={(e)=> this.toTrendsPage(e, this.bundle.single_item.trends_page)}/></div>
            } else {
                trendsLink = <Fragment>
                    <a className='bundle-cta' onClick={(e)=>this.toTrendsPage(e, this.bundle.single_item.trends_page)}>{i18n.getString('myAccount::bundle::valueSummary')}</a>
                    <span className='separator'> | </span>
                </Fragment>
            }
        }
        return trendsLink
    }

    openBundle = () => {
        browserHistory.push(`/items/${this.bundle.id}`);
        this.props.getBundleWithItems(this.bundle.id);
    }

    onBundleClick = (e) => {
        if (this.props.open) return;
        const isSingleValuable = this.isSingleItem,
            objectType = isSingleValuable ? 'Item' : 'Bundle',
            objectId = isSingleValuable ? this.props.itemPublicId : this.bundle.id,
            event = `Seller clicked on ${isSingleValuable ? 'valuable' : 'bundle'} #${objectId}`;
        UserActions.myAccount(event, objectId, objectType);
        if (isSingleValuable)
            if (this.bundle.single_item.workflow_state === EVALUATION_BID) window.location = siteItemPage(this.bundle.single_item.public_id);
            else this.scheduleACall(e);
        else
            this.openBundle();
    }

    successFeesClicked = () => {
        UserActions.myAccount(`Seller clicked on fees link for bundle #${this.bundle.id}`, this.bundle.id, 'Bundle');
        PopupJBSuccessFees.initPopup({
            bundleId: this.bundle.id,
            feesRate: this.bundle.jb_fees_rate,
        });
    }

    getPaid = () => {
        this.props.getPaymentDetails().then((res) => {
            let paymentDetails = res.payload.data.payment_details;
            let evaluationSellRatio = this.bundle.evaluation_sell / this.totalValue;
            let remainingRatio  = evaluationSellRatio < 1 ?  1 - evaluationSellRatio : evaluationSellRatio - 1;
            let feesRate = Math.round( remainingRatio * 100);

            if (paymentDetails.transfer_type === 'bank_transfer' && !paymentDetails.bank) // no payment details for the user
                browserHistory.push(`/user/payment_details?action=getPaid&bundleId=${this.bundle.id}&totalValue=${this.totalValue}&f=${btoa(feesRate)}`,);
            else
                PopupJBGetPaid.initPopup({
                    bundleId: this.bundle.id,
                    totalValue: this.totalValue,
                    paymentDetails: paymentDetails,
                    feesRate: feesRate
                });
        })
        UserActions.myAccount(`Seller clicked 'Get paid' on bundle #${this.bundle.id}`, this.bundle.id, 'Bundle');
    }

    renderTitle() {
        let caption;
        if (this.isMobile) {
            caption = this.bundle.single_item ? `${ this.bundle.single_item.major_subset_type } #${this.bundle.single_item.public_id}` : `Bundle #${this.bundle.id}`
        } else {
            caption = this.multipleItems ? `Bundle #${this.bundle.id}` : `Valuable #${this.props.itemPublicId}`
        }

        if (this.props.open) {
            return <div className='title'>{`${this.itemsCount} ${this.multipleItems || this.itemsCount === 0 ? 'valuables' : 'valuable'}`}</div>;
        } else {
            return (
                <Fragment>
                    <span className={'title bold'}>
                        { caption }
                    </span>
                    <div className='subtitle'>{this.multipleItems ? `${this.itemsCount} valuables` : this.bundle.single_item?.desc}</div>
                </Fragment>
            )
        }
    }
    renderThreeDotsMenu() {
         return ( <div className="three-dots-wrapper">
             <ThreeDotsMenu
            options={[
                  {
                     optionText: 'Cancel submission',
                     handler: () => {
                         return popupSubmitItemCancelleation.initPopup({
                             itemPublicId: this.props.itemPublicId,
                              rerenderParentCallback: ()=>this.renderParent(this.props.bundle)
                         });

                     },
                     optionIconUrl: imageUrl('common/abortItem.png')
                  }]}
            />
         </div>)
    }

    renderParent = (bundle)=>{

        if (this.props.open) {
                this.props.getBundleWithItems(this.props.bundle.id)
                    .then((res)=> {
                    this.setState({items: res.payload.items || []})
                    rootStore.dispatch(getItemsCount(this.props.Session.userData.id))
                    if (this.itemsCount > 0 )
                    this.props.rerenderParentCallback(bundle);

                   })
        }
        else
            this.props.rerenderParentCallback(bundle);

    }

    toTrackPackage = (cb) => {
        if (typeof cb === 'function') {
            cb();
        }
        UserActions.myAccount(`Seller viewed "Track Package" #${this.bundle.id}`, this.bundle.id, 'Bundle');
        window.open(this.bundle.tracking_url)
    }

    stopBubblingUp = e => {
        e.stopPropagation();
    }

    renderCTA() {
        const singleItem = this.bundle.single_item;
        const IS_WATCH = singleItem && singleItem.major_subset_type === 'Watch';
        const SHIPMENT_NOT_SCHEDULED = [ESTIMATED, ADDRESS_WAITING, PICKUP_WAITING].includes(this.bundle.workflow_state) && !this.bundle.shipment_method && this.bundle.type === "standard" && this.isSingleItem;
        const PICKUP_DID_NOT_HAPPENED = this.bundle.shipment_method === PICKUP_NO_SHOW;
        const IS_JB = this.bundle.type === 'jewelry_box';
        const JB_OR_HV = IS_JB || this.bundle.expensive_item;
        const JB_OR_HV_WITHOUT_A_CALL = [NEW, ESTIMATED, ADDRESS_WAITING].includes(this.bundle.workflow_state) && (!this.bundle.appointment_time && JB_OR_HV);
        const JB_OR_HV_WITH_A_CALL = [NEW, ESTIMATED].includes(this.bundle.workflow_state) && (this.bundle.appointment_time && JB_OR_HV);
        const BUNDLE_IN_TRANSIT = this.bundle.workflow_state === IN_TRANSIT;
        const ITEM_IN_PENDING_AUCTION = singleItem && singleItem.workflow_state === PENDING_AUCTION;
        const ABORTED = singleItem && singleItem.aborted || this.bundle.aborted;
        const ITEM_HAS_OFFER = [PENDING_SALE, BIDDING_FINISHED].includes(singleItem && singleItem.workflow_state) && !ABORTED;
        const WAS_SOLD = [ON_HOLD, SALE_SCHEDULED, DONE].includes(singleItem && singleItem.workflow_state) && !ABORTED;
        const AUCTION_FINISHED = (this.bundle.workflow_state === EVALUATED) && (singleItem && singleItem.workflow_state === EVALUATION_READY);
        const MONEY_PAID_TO_USER = this.bundle.workflow_state === DONE_SOLD && (singleItem && singleItem.workflow_state === DONE);
        const ITEM_IN_QUICKSALE = this.bundle.workflow_state === PENDING_SALE && (singleItem && singleItem.workflow_state === PENDING_SALE);
        const ITEM_BIDDING_FINISHED = singleItem && singleItem.workflow_state === BIDDING_FINISHED;
        const ITEM_DONE = this.bundle.workflow_state === DONE && (singleItem && singleItem.workflow_state === DONE);
        const PHOTO_MANDATORY = singleItem && singleItem.is_photo_mandatory;
        const ITEM_FORMAT_TENDER = singleItem && singleItem.format === 'tender';
        const ITEM_SCHEDULED_AUCTION = singleItem && singleItem.scheduled_auction;

        let CTA_BUTTON;
        const template = () => <div className={`cta-container ${this.isMobile && CTA_BUTTON ? ' with-button ' : '' }`}>
            { ((this.isMobile && CTA_BUTTON) || ITEM_SCHEDULED_AUCTION) ? null : <span className='status'>{ this.statusText }</span> }
            { CTA_BUTTON }
        </div>;

        const eligibleForLP = this.state.eligibleForLP;

        if (this.isMobile) {
            if (!this.props.open && typeof eligibleForLP === 'undefined') return null;
            // We do not touch anything inside JB so far
            const schedule_pickup_btn = <div className='cta-wrapper d-flex' data-automation={ dataAutomationAttr('schedule') }>
                <SmallPrimaryButton
                    click={ cb => this.toItemPage(cb) }
                    text={ i18n.getString('myAccount::bundle::schedulePickup') }/>
                {this.trendsLink()}
            </div>;

            const edit_pickup_btn = <div className='cta-wrapper d-flex' data-automation={ dataAutomationAttr('edit-pickup') }>
                <SmallPrimaryButton
                    click={ cb => this.toItemPage(cb) }
                    text={ i18n.getString('myAccount::bundle::editPickup') }/>
                {this.trendsLink()}
            </div>;

            if (ITEM_IN_PENDING_AUCTION && ITEM_SCHEDULED_AUCTION) {
                CTA_BUTTON = (
                    <div
                        className="cta-wrapper"
                        data-automation={dataAutomationAttr("start-auction")}
                    >
                        <span className="status" style={{ color: '#F5A723' }}>
                            {i18n.getString(
                                "itemPage::scheduledAuction::titleScheduled"
                            )}
                        </span>
                    </div>
                );
                return template();
            }

            if (ABORTED && ITEM_DONE) {
                return template();
            }

            if (IS_WATCH) {
                if (ITEM_IN_QUICKSALE || ITEM_IN_PENDING_AUCTION || AUCTION_FINISHED || ITEM_BIDDING_FINISHED || WAS_SOLD && !MONEY_PAID_TO_USER) {
                    CTA_BUTTON = <div className='cta-wrapper' data-automation={ dataAutomationAttr('see-offer') }>
                        <SmallPrimaryButton click={ cb => this.toItemPage(cb) } text={i18n.getString(`myAccount::bundle::${ ITEM_IN_PENDING_AUCTION || ITEM_IN_QUICKSALE ? 'startAuction' : 'seeOffer' }`)}/>
                    </div>
                }
                return template();
            }

            if (AUCTION_FINISHED) {
                // In the meantime we don't show anything status for "Support negotiation" process
                return null;
            }

            if (ITEM_HAS_OFFER || ITEM_IN_QUICKSALE) {
                CTA_BUTTON = <div className='cta-wrapper' onClick={ this.stopBubblingUp } data-automation={ dataAutomationAttr('see-offer') }>
                    <SmallPrimaryButton click={ cb => this.toItemPage(cb) } text={i18n.getString(`myAccount::bundle::seeOffer`)}/>
                </div>;
                return template();
            }

            if (WAS_SOLD) {
                return template()
            }

            if (JB_OR_HV_WITHOUT_A_CALL && !eligibleForLP) {
                CTA_BUTTON = <div className='cta-wrapper d-flex' onClick={ this.stopBubblingUp } data-automation={ dataAutomationAttr('jb-or-hv-schedule-pickup') }>
                    <SmallPrimaryButton click={ cb => this.scheduleACall(cb) } text={ i18n.getString(`myAccount::bundle::scheduleCall`) }/>
                    {this.trendsLink()}
                </div>;
                return template();
            }

            if (JB_OR_HV_WITH_A_CALL) {
                if (eligibleForLP) {
                    CTA_BUTTON = <div className='cta-wrapper d-flex' onClick={ this.stopBubblingUp } data-automation={ dataAutomationAttr('jb-or-hv-edit-pickup') }>
                        <SmallPrimaryButton click={ cb => this.scheduleACall(cb) } text={ i18n.getString('myAccount::bundle::editPickup') }/>
                        {this.trendsLink()}
                    </div>;
                }
                return template();
            }

            if (PHOTO_MANDATORY) {
                CTA_BUTTON = <Fragment>
                    {this.trendsLink()}
                    &nbsp;
                    <a className='bundle-cta no-margin' onClick={this.toItemPage}>{i18n.getString('myAccount::bundle::pendingReview')}</a>
                </Fragment>
                return template();
            }

            if (SHIPMENT_NOT_SCHEDULED || PICKUP_DID_NOT_HAPPENED) {
                CTA_BUTTON = schedule_pickup_btn;
                return template();
            } else {
                if ([ADDRESS_WAITING, PICKUP_WAITING].includes(this.bundle.workflow_state) &&
                    this.bundle.shipment_method) {
                        if (this.isSingleItem) {
                            if (eligibleForLP) {
                                if (this.bundle.pickup_time_range || this.bundle.shipment_method === 'Dropoff') {
                                    CTA_BUTTON  = edit_pickup_btn;
                                } else {
                                    CTA_BUTTON  = schedule_pickup_btn;
                                }
                            } else {
                                CTA_BUTTON  = schedule_pickup_btn;
                            }
                        } else {
                            CTA_BUTTON = null;
                        }
                    return template();
                }
            }

            if (BUNDLE_IN_TRANSIT) {
                CTA_BUTTON = <div className='cta-wrapper' data-automation={ dataAutomationAttr('track-package') } onClick={ this.stopBubblingUp }>
                    <SmallPrimaryButton
                    click={ cb => this.toTrackPackage(cb) }
                    text={ i18n.getString('myAccount::bundle::trackPackage') }/>
                </div>;
                return template();
            }

            if (ITEM_IN_PENDING_AUCTION && !ITEM_FORMAT_TENDER) {
                CTA_BUTTON = <div className='cta-wrapper' data-automation={ dataAutomationAttr('start-auction') }>
                    <SmallPrimaryButton click={ cb => this.toItemPage(cb) } text={i18n.getString('myAccount::bundle::startAuction')}/>
                </div>;
                return template();
            }

        } else {
            if (ITEM_IN_PENDING_AUCTION && ITEM_SCHEDULED_AUCTION) {
                CTA_BUTTON = (
                    <a className="bundle-cta" onClick={this.toItemPage}>
                        {i18n.getString(
                            "itemPage::scheduledAuction::titleScheduled"
                        )}
                    </a>
                );
                return template();
            }

            if (JB_OR_HV_WITHOUT_A_CALL) {
                CTA_BUTTON = <Fragment>
                        {this.trendsLink()}
                        <a className='bundle-cta no-margin' onClick={this.scheduleACall}>{i18n.getString('myAccount::bundle::scheduleCall')}</a>
                    </Fragment>
                return template();
            }

            if (JB_OR_HV_WITH_A_CALL) {
                CTA_BUTTON= <Fragment>{i18n.getString('myAccount::bundle::callScheduledFor')} {parseShortenedDate(this.bundle.appointment_time)}</Fragment>
                return template();
            }

            if (PHOTO_MANDATORY) {
                CTA_BUTTON = <Fragment>
                    {this.trendsLink()}
                    &nbsp;
                    <a className='bundle-cta no-margin' onClick={this.toItemPage}>{i18n.getString('myAccount::bundle::pendingReview')}</a>
                </Fragment>
                return template();
            }

            if (SHIPMENT_NOT_SCHEDULED) {
                CTA_BUTTON = <Fragment>
                    {this.trendsLink()}
                    <a className='bundle-cta no-margin' onClick={this.toItemPage}>{i18n.getString('myAccount::bundle::setUpShipping')}</a>
                </Fragment>
                return template();
            }

            if (BUNDLE_IN_TRANSIT) {
                CTA_BUTTON = <a className='bundle-cta' href={this.bundle.tracking_url} onClick={this.toTrackPackage}>{i18n.getString('myAccount::bundle::trackPackage')}</a>;
                return template();
            }

            if (ITEM_IN_PENDING_AUCTION && !ITEM_FORMAT_TENDER) {
                CTA_BUTTON = <a className='bundle-cta' onClick={this.toItemPage}>{i18n.getString('myAccount::bundle::startAuction')}</a>;
                return template();
            }
        }
        return template();
    }

    renderFooter() {
        if (this.transferDetails || !this.state.allFinished || this.state.items.some((item) => {
            return item.aborted || item.return_requested || item.workflow_state === RETURN_PENDING;
        })) return null;
        return (
            <footer id='get-paid'>
                <div className='inner'>
                    <button className='btn btn-orange' data-automation={dataAutomationAttr('get-paid')} onClick={this.getPaid}>GET PAID</button>
                    <div className="text-box">
                        <div>
                            Total: {<b>{dollarsWithoutCents(this.totalValue)}</b>}
                        </div>
                        <div className="help">
                            {
                                I18n.getJsx('myAccount::successFeesLink', {
                                    link: <a onClick={this.successFeesClicked}>
                                            {I18n.getString("myAccount::successFeesLinkText")}
                                          </a>
                                })
                            }
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    renderBanner() {
        if (!this.props.open || !this.transferDetails || this.transferDetails.done) return null;
        let feesRate = (1 - (this.transferDetails.amount/this.totalValue)) * 100;

        return (
            <div className='green-banner'>
                {
                    this.transferDetails.additional ?
                      I18n.getJsx('myAccount::bannerPaymentSuccessfulAdditional', {
                          valueAfterFees: <span>{dollarsWithoutCents(this.transferDetails.amount)}</span>,
                          numValuables: <span>{`${this.itemsCount} ${this.isSingleItem ? 'valuable' : 'valuables'}`}</span>
                      })
                      :
                      I18n.getJsx('myAccount::bannerPaymentSuccessful', {
                          valueAfterFees: <span>{dollarsWithoutCents(this.transferDetails.amount)}</span>,
                          valueBeforeFees: <span>{dollarsWithoutCents(this.totalValue)}</span>,
                          feesRate: <span>{feesRate.toFixed(1)}%</span>,
                          numValuables: <span>{`${this.itemsCount} ${this.isSingleItem ? 'valuable' : 'valuables'}`}</span>
                      })
                }
            </div>
        )
    }

    render() {
        const {ADO: {experiments}} = this.props
        const clickableClass = this.clickable && 'clickable' || '';
        const abortableClass = this.singleAndPreDelivery && 'abortable' || '';
        const showCancelItemOption = experiments?.online_cancel_action?.variant === 'true'
        let caption;
        let icon;

        if (this.isMobile) {
            caption = this.bundle.single_item ? `${ this.bundle.single_item.major_subset_type } #${this.bundle.single_item.public_id}` : `BUNDLE #${this.bundle.id}`
            icon = dataAutomationAttr(this.bundle.single_item && this.bundle.single_item.major_subset_type ? this.bundle.single_item.major_subset_type : '')
        } else {
            caption = this.isSingleItem ? `VALUABLE #${this.bundle.single_item?.public_id}` : `BUNDLE #${this.bundle.id}`
        }
        return (
            <div className={`bundle-details ${clickableClass}  ${showCancelItemOption ? abortableClass : ''} 
             ${this.props.open ? ' open ' : ' closed '} ${this.props.first ? 'first' : ''}`}>
                {this.renderBanner()}
                {
                    this.props.open ?
                        <div>
                            <h1> { caption } </h1>
                            <span className='created-at'>{this.bundle.created_at}</span>
                        </div>
                        :
                        null
                }

                <div

                    data-automation={dataAutomationAttr(`item-${this.bundle['single_item'] ? this.bundle['single_item']['major_subset_type'] : ''}-tab`)}
                    className={`row-header ${clickableClass}`}
                    onClick={this.clickable ? this.onBundleClick : null}>
                    <span className='title-container'>
                        <span className={`box ${ icon } ${this.props.open ? 'open' : ''}`}/>
                        { this.renderTitle()}

                    </span>
                    {
                        !this.props.open && !this.isMobile?
                            <span className='created-at'>{this.bundle.created_at}</span> : null
                    }
                    { this.bundle.single_item?.is_direct_offer ? null : this.renderCTA() }

                </div>
                {  !this.props.open && showCancelItemOption && this.singleAndPreDelivery && this.renderThreeDotsMenu()}
                {

                    this.props.open ?
                        <Fragment>
                            {
                                this.state.items.map((item, i) => {
                                    return (
                                        <div className={ `panel panel_${i}` } key={item.public_id}>
                                            <ItemDetails item={item}
                                                         bundleCount={this.state.items.length}
                                                         bundle={this.bundle}
                                                         bundleType={this.bundle.type}
                                                         bundleId={this.bundle.id}
                                                         lastViewed={this.bundle.last_viewed}
                                                         clickablePendingSale={this.bundle.clickable_pending_sale}
                                                         allFinished={this.state.allFinished}
                                                         anyInAuction={this.anyInAuction}
                                                         cancelItemOption={showCancelItemOption}
                                                         rerenderParentCallback= {this.renderParent}
                                            />
                                        </div>
                                    )
                                })
                            }
                            {this.renderFooter()}
                        </Fragment>
                        :
                        null
                }
            </div>

        )
    }
}

const mapStateToProps = ({ ADO, MyAccount, Personalized, Session}) => {
    return { ADO, MyAccount, P13N: Personalized, Session }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getBundleWithItems,
        getPaymentDetails,
        preShipmentUi,
        abortItem,
        getUserBundles,
        clearSelectedBundle
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleDetails);
